












































import Vue from 'vue';
import Component from 'vue-class-component';
import TopPanel from './TopPanel.vue';
import WelcomeCard from './WelcomeCard.vue';
import LoaderTopPanel from './LoaderTopPanel.vue';
import LoaderMyMovies from './LoaderMyMovies.vue';
import ServiceAgent from '@/services/serviceAgent';
import EventBus from '@/services/eventBus';
import Privacy from '@/components/appStore/Privacy.vue';
import Support from '@/components/appStore/Support.vue';

const serviceAgent = new ServiceAgent();

@Component({
    components: {
        TopPanel,
        WelcomeCard,
        LoaderTopPanel,
        LoaderMyMovies,
        Privacy,
        Support,
    },
})
export default class Main extends Vue {
    snackbarOpened = false;

    snackbarText = '';

    snackbarSuccess = false;

    showLoader = false;

    isMoviesLoading = false;

    get isUserAuthorized() {
        const result = this.$store.getters.isUserAuthorized;

        return result;
    }

    get isLoaded() {
        const result = this.$store.getters.isLoaded;

        return result;
    }

    created() {
        this.$store.dispatch('setIsUserAuthorized');

        EventBus.$on('openSnackbar', (data: any) => {
            this.snackbarOpened = true;
            this.snackbarText = data.snackbarText;
            this.snackbarSuccess = data.snackbarSuccess;
        });

        EventBus.$on('showLoader', (value: any) => {
            this.showLoader = value;
        });

        EventBus.$on('setMoviesLoading', (value: any) => {
            this.isMoviesLoading = value;
        });
    }
}
